import { Button, InputAdornment, Modal, TextField } from '@mui/material';
import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import request from '../../../Helpers/API';
import { LoaderScreen } from '../../components/LoaderScreen';
import { FormatMoney } from '../../../Helpers/FormatNumber';

export const ModalAgregarPromociones = ({ open, handleClose, datos, ObtenerListado }) => {
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });
    const [promocion, setPromocion] = useState({ descripcion: "", vigencia: "" });

    const handleChange = (e) => {
        setPromocion({ ...promocion, descripcion: e.target.value }); // Actualiza el valor de descripcion al escribir
    };
    const handleDateChange = (e) => {
        setPromocion({ ...promocion, vigencia: e.target.value }); // Actualiza el valor de vigencia
    };

    const onGuardar = () => {
        // console.log(formData)
        const post = {
            idpromocion: -99,
            idinventario: datos.idinventario,
            descripcion: promocion.descripcion,
            vigencia: promocion.vigencia,
        }

        request
            .post("ListadoPreciosProductoAliado/GuardarPromocion", post)
            .then(async () => {
                setLoader({ ...loader, mostrar: false });
                handleClose();
                Swal.fire("PROMOCIONES", "Promocion modificada con éxito", "success");
                ObtenerListado();
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("PROMOCIONES", JSON.stringify(error), "error");
            });
    };

    return (
        <Modal open={open}>
            <div className="otros-modal">
                <LoaderScreen loader={loader} />
                <div className="otros-modal-title">
                    <div className="filtro-soy-el-titulo-header">
                        <h3>AGREGAR PROMOCION</h3>
                    </div>
                </div>
                <div className="imagen-modal-soy-el-titulo-line">
                    <div className="imagen-modal-soy-el-titulo-line-bl"></div>
                    <div className="imagen-modal-soy-el-titulo-line-circle"></div>
                    <div className="imagen-modal-soy-el-titulo-line-br"></div>
                </div>

                <div className='Modal-Promociones-inputs-Container'>
                    <div className="">
                        <TextField
                            id="promocion"
                            label="Promoción"
                            type="text"
                            value={promocion?.descripcion} // Mostrar comas mientras escribe
                            onChange={handleChange}
                            sx={{ mb: 2, width: 540 }}
                        />
                    </div>
                    <div>
                        <TextField
                            id="vigencia"
                            label="Vigencia"
                            type="date"
                            value={promocion.vigencia}
                            onChange={handleDateChange}
                            sx={{ mb: 2, width: 540 }}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </div>
                </div>
                <div className="promociones-modal-button-container">
                    <div className="cerrar-button" onClick={handleClose} style={{ cursor: "pointer" }}>
                        Cerrar
                    </div>
                    <div className="right-buttons">
                        <div className="agregar-button"
                            onClick={onGuardar}
                            style={{ cursor: "pointer" }}>
                            Agregar
                        </div>
                    </div>
                </div>

            </div>
        </Modal>
    )
};